import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteProps } from 'react-router';
import { injectIntl } from 'react-intl';
import messages from './messages';

import { ROUTE_LAUNCHING_ROCKET } from '../../RouteList';
import Button, { ButtonType } from '../../components/button/button';

import Image, { ImageType } from '../../components/image/image';
import Container from '../../components/layout/container';

import classNames from 'classnames';
import Tester from './components/Tester';

const sortSessionSportersCompletedAndName = persons => {
  const personsDone = sortByName(persons.filter(person => person.finished));
  const personsTodo = sortByName(persons.filter(person => !person.finished));
  return [...personsTodo, ...personsDone];
};

const sortByName = persons => {
  return persons.sort((a, b) => {
    if (a.firstname.toLowerCase() > b.firstname.toLowerCase()) return 1;
    if (a.firstname.toLowerCase() < b.firstname.toLowerCase()) return -1;
    if (a.lastname.toLowerCase() > b.lastname.toLowerCase()) return 1;
    if (a.lastname.toLowerCase() < b.lastname.toLowerCase()) return -1;
    return 0;
  });
};

@inject('routing', 'dataStore')
@observer
class Testers extends React.Component<RouteProps & any, any> {
  public render() {
    const {
      routing: { push },
      intl,
      dataStore: { sporters, isPrivate, isSportVlaanderen }
    } = this.props;
    return (
      <React.Fragment>
        <div className={classNames('c-result')}>
          <Image
            type={ImageType.resultsTitle}
            imgSrc="/images/svg/result-bord.svg"
            alt={'Title'}
            extraClasses={'c-image--bord c-image--bord-tester'}
            text={intl.formatMessage(messages.intro)}
          />
          <Image
            type={ImageType.resultsHeader}
            imgSrc="/images/svg/result-foreground.svg"
            alt={'Clouds'}
            extraClasses={'c-image--foreground'}
          />
          <Image
            type={ImageType.resultsHeader}
            imgSrc="/images/svg/result-background-fine.svg"
            alt={'Clouds'}
            extraClasses={'c-image--background'}
          />
        </div>

        {!isPrivate && !isSportVlaanderen && (
          <div className={classNames('c-result__buttons')}>
            <Button
              type={ButtonType.circleBack}
              onClick={() => push(ROUTE_LAUNCHING_ROCKET)}
            />
          </div>
        )}

        <Container
          extraClasses={classNames('c-container--result c-container--testers', {
            'is-private': isPrivate
          })}
        >
          {sortSessionSportersCompletedAndName(sporters).map(tester => (
            <Tester key={tester.id} {...tester} />
          ))}
        </Container>
      </React.Fragment>
    );
  }
}

export default injectIntl(Testers);



// WEBPACK FOOTER //
// ./src/containers/testers/Testers.tsx